import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import TestDetails from '../testDetails';
import { useEffect, useState } from 'react';

const removeHTML = (str) => {
	const tmp = document.createElement('p');
	tmp.innerHTML = str;
	return tmp.textContent || tmp.innerText || '';
};

const TestType = ({ name, slug, cta, testsApi }) => {
	const [products, setProducts] = useState({});
	const [description, setDescription] = useState('');

	useEffect(() => {
		if (testsApi) {
			let obj = testsApi.find((product) => product.sku === slug);
			if (obj) {
				const categories = obj.cc_test_category;
				const method = obj.cc_test_mechanism;
				const cost = obj.price;
				const processingTime = obj.cc_processing_time;
				setDescription(removeHTML(obj.short_description));
				setProducts({
					categories,
					method,
					cost,
					processingTime,
				});
			}
		}
	}, []);

	return (
		<div className="test-type">
			<h5 className="typography typography--h5 typography--white">{name}</h5>
			<div className="test-type__info">
				{description && (
					<p className="typography typography--body-small typography--white">
						{description}
					</p>
				)}
				{cta && (
					<Link
						className="typography typography--body-small typography--white"
						to={cta.link}
					>
						{cta.title}
					</Link>
				)}
			</div>
			{products && (
				<TestDetails className="typography typography--white" data={products} />
			)}
			<a href={`${process.env.GATSBY_MAGENTO_PROD_BASE}/pick-a-location/`}>
				<button className="btn btn--white">{`Book ${name}`}</button>
			</a>
		</div>
	);
};

TestType.propTypes = {
	name: PropTypes.string.isRequired,
	slug: PropTypes.string.isRequired,
	testsApi: PropTypes.any,
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	}).isRequired,
};

export default TestType;
